import { Text, Paper, Stack, Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Widget as TypeformWidget } from '@typeform/embed-react';
import classes from './Feedback.module.css';

export const Feedback = () => {
  const { t } = useTranslation();

  return (
    <Paper shadow={'sm'} radius={'md'} p={'md'} withBorder>
      <Stack>
        <Text>{t('feedback_description')}</Text>
        <Flex>
          <TypeformWidget id={'i85nZNn1'} width={'100%'} className={classes.feedback} />
        </Flex>
      </Stack>
    </Paper>
  );
};
